import React, { useState, useEffect } from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import { FaShoppingBag } from "react-icons/fa";

const Header = ({ onSearchChange, bagCount = 0 }) => {
  const navigate = useNavigate();

  // -----------------------------------------------------------
  // ADDED: Popup state (NO CHANGE IN FUNCTIONALITY)
  // -----------------------------------------------------------
  const [showOrdersPopup, setShowOrdersPopup] = useState(false);
  const [mobileInput, setMobileInput] = useState("");
  const [orders, setOrders] = useState([]);

  // -----------------------------------------------------------
  // ADDED: Listener for event from PublicStorePage
  // -----------------------------------------------------------
  useEffect(() => {
    const handler = () => setShowOrdersPopup(true);
    window.addEventListener("open-orders-modal", handler);
    return () => window.removeEventListener("open-orders-modal", handler);
  }, []);

  // -----------------------------------------------------------
  // ADDED: Fetch user orders (same functionality as before)
  // -----------------------------------------------------------
  const fetchOrders = async () => {
    if (!mobileInput.trim()) {
      alert("Please enter mobile number");
      return;
    }

    try {
      const res = await fetch(
        `https://clothconnect-backend-hsb1.onrender.com/api/orders?mobile=${mobileInput}`
      );
      const data = await res.json();
      if (data.success) {
        setOrders(data.orders || []);
      }
    } catch (err) {
      console.error("Order fetch error:", err);
    }
  };

  return (
    <>
      {/* -----------------------------------------------------------
         ORIGINAL HEADER (UNCHANGED)
      ------------------------------------------------------------ */}
      <header className="main-header">
        <div className="header-left">
          <img
            src="/logo.jpg"
            alt="Logo"
            className="header-logo"
            onClick={() => navigate("/store")}
          />

          <nav className="nav-menu">
            <span onClick={() => onSearchChange("cotton")}>Cotton</span>
            <span onClick={() => onSearchChange("silk")}>Silk</span>
            <span onClick={() => onSearchChange("lehenga")}>Lehenga</span>
            <span onClick={() => onSearchChange("net")}>Net</span>
            <span onClick={() => onSearchChange("banaras")}>Banaras</span>
            <span onClick={() => onSearchChange("velvet")}>Velvet</span>

            <input
              type="text"
              placeholder="Search products..."
              className="header-search-input"
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </nav>
        </div>

        <div className="header-right">
          {/* My Orders — unchanged trigger */}
          <div
            className="nav-item"
            onClick={() => {
              window.dispatchEvent(new Event("open-orders-modal"));
            }}
          >
            My Orders
          </div>

          {/* Bag */}
          <div className="header-icon" onClick={() => navigate("/bag")}>
            <FaShoppingBag size={18} />
            <span>Bag{bagCount > 0 ? ` (${bagCount})` : ""}</span>
          </div>
        </div>
      </header>

      {/* -----------------------------------------------------------
         POPUP MERGED BELOW — NO IMPACT ON HEADER LAYOUT
      ------------------------------------------------------------ */}
      {showOrdersPopup && (
        <div className="orders-popup-overlay">
          <div className="orders-popup">
            <h2>Your Orders</h2>

            {/* Mobile Input */}
            <input
              className="orders-input"
              placeholder="Enter Mobile Number"
              value={mobileInput}
              onChange={(e) => setMobileInput(e.target.value)}
            />

            <div className="orders-buttons">
              <button className="btn-view" onClick={fetchOrders}>
                View Orders
              </button>
              <button
                className="btn-close"
                onClick={() => {
                  setShowOrdersPopup(false);
                  setOrders([]);
                  setMobileInput("");
                }}
              >
                Close
              </button>
            </div>

            {/* ORDER LIST */}
            <div className="order-list">
              {orders.length === 0 && (
                <p style={{ textAlign: "center", marginTop: "20px" }}>
                  No orders found.
                </p>
              )}

              {orders.map((order) => (
                <div className="order-card" key={order._id}>
                  <img
                    className="order-image"
                    src={order.selectedImage || order.imageUrl}
                    alt={order.productName}
                  />
                  <div className="order-info">
                    <div className="order-title">{order.productName}</div>
                    <div className="order-price">₹{order.amount}</div>
                    <div className="order-status">Status: {order.status}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
